module.exports = __webpack_public_path__ + "static/media/delete_with_background.bc06b3fd.svg";